module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/evvnt_ticketing_wider-9abae4ea88d3ef91b4278a3fb968e660.png";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/evvnt_ticketing_wider.png
// module id = 1549
// module chunks = 0